import React, { useState } from 'react'
import TagManager from 'react-gtm-module';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Title from './Title';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Description from './Description';
import { useNavigate } from 'react-router-dom';

const LoginForm = () => {
  const [showError, setShowError] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [resetEmailSent, setResetEmailSent] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const navigate = useNavigate();

  // Email validation regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const Register = () => {
      navigate('/register');
  }

  const handleSignIn = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowError(true);
  }

  const handleForgotPassword = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowForgotPassword(true);
    setShowError(false); // Hide sign in error when showing forgot password
    setResetEmailSent(false); // Reset the email sent state
    setEmailError(''); // Clear any email errors
  }

  const handleResetSubmit = (e: React.MouseEvent) => {
    e.preventDefault();
    
    // Validate email
    if (!resetEmail.trim()) {
      setEmailError('Please enter an email address');
      return;
    }
    
    if (!emailRegex.test(resetEmail)) {
      setEmailError('Please enter a valid email address');
      return;
    }
    
    // If validation passes, clear error and show success message
    setEmailError('');
    setResetEmailSent(true);
  }

  return (
    <div className='login-form-box'>
      <div className='hero-logo-box'>
        <img src='../images/logo.png' style={{ height: '100px' }} alt="DressTwin logo" />
        <div className='hero-logo-title'>
          <Title
            textAlign="center"
            textColor="black"
            fontSize="30px"
            fontWeight="600"
            content="DressTwin"
          />
        </div>
        <div className='hero-logo-desc'>
          <Description
            textColor="#444"
            textAlign="center"
            content="A social fashion marketplace where every item you see fits you—literally."
          />
        </div>
      </div>
      <Title
        textAlign="center"
        textColor="black"
        fontSize="30px"
        fontWeight="600"
        content="Sign in"
      />
      <br />
      <form className='login-form'>
        {!showForgotPassword ? (
          <>
            <TextField id="outlined-basic" label="Email" variant="outlined" fullWidth={true} />
            <TextField id="outlined-basic" label="Password" variant="outlined" fullWidth={true} />
            {showError && (
              <div style={{ color: 'red', fontSize: '14px', textAlign: 'center', marginTop: '10px' }}>
                Wrong username and password
              </div>
            )}
            <button type="button" onClick={handleSignIn} className="form-link register-link" style={{ textDecoration: 'none', color: 'black', display: 'flex', alignItems: 'center', background: 'none', border: 'none', cursor: 'pointer' }}>
              <span className='forgot-password'>Sign in</span>
              <NavigateNextIcon />
            </button>
            <button type="button" onClick={handleForgotPassword} className="form-link forgot-password-link" style={{ textDecoration: 'none', color: 'black', display: 'flex', alignItems: 'center', background: 'none', border: 'none', cursor: 'pointer' }}>
              <span className='forgot-password'>Forgot your password?</span>
              <NavigateNextIcon />
            </button>
          </>
        ) : (
          <>
            <Title
              textAlign="center"
              textColor="black"
              fontSize="24px"
              fontWeight="600"
              content="Reset Password"
            />
            <Description
              textColor="#666"
              textAlign="center"
              content="Enter your email address and we'll send you reset instructions if your account exists."
            />
            <TextField 
              id="reset-email" 
              label="Email Address" 
              variant="outlined" 
              fullWidth={true}
              value={resetEmail}
              onChange={(e) => {
                setResetEmail(e.target.value);
                setEmailError(''); // Clear error when user types
              }}
              error={!!emailError}
              helperText={emailError}
            />
            {resetEmailSent && (
              <div style={{ color: 'green', fontSize: '14px', textAlign: 'center', marginTop: '10px', padding: '10px', backgroundColor: '#f0f8f0', borderRadius: '4px' }}>
                If your account exists, reset instructions will be sent to your email address.
              </div>
            )}
            <Button
              type="button"
              onClick={handleResetSubmit}
              variant="contained"
              size="large"
              fullWidth={true}
              style={{ backgroundColor: '#996633', color: '#fff' }}
            >
              Send Reset Instructions
            </Button>
            <button type="button" onClick={(e) => { 
              e.preventDefault(); 
              setShowForgotPassword(false); 
              setResetEmailSent(false); 
              setResetEmail(''); 
              setEmailError(''); 
            }} style={{ textAlign: 'center', color: '#996633', textDecoration: 'none', marginTop: '10px', background: 'none', border: 'none', cursor: 'pointer' }}>
              Back to Sign In
            </button>
          </>
        )}
        {!showForgotPassword && (
          <Button
              type="button"
              onClick={(e) => {
                e.preventDefault();

                TagManager.dataLayer({
                  dataLayer: {
                      event: 'event_HomeSignInBtnClick'
                  }
               });
                Register();
                }}
              variant="contained" size="large" fullWidth={true}>Join now
            </Button>
        )}
      </form>
    </div>
  )
};

export default LoginForm